<script lang='ts'>
  import type { CompletedPuzzle } from "./state"

  export let current_page

  export let completed_puzzles:CompletedPuzzle[]
  $: best_puzzle = completed_puzzles.sort((a,b) => a.score - b.score)[0]
  $: average_score = get_average_score(completed_puzzles)
  $: distribution = get_distribution(completed_puzzles)
  $: most_common_score = distribution.sort((a,b) => b.count - a.count)[0]?.count

  function get_average_score(puzzles:CompletedPuzzle[]):string {
    const total = puzzles.reduce((prev, curr) => {
      return prev + curr.score
    },0)
    const count = puzzles.length
    return (total/count).toFixed(1)
  }
  interface Reveal_Count {reveals: number, count: number}
  function get_distribution(puzzles:CompletedPuzzle[]):Reveal_Count[] {
    const results:any = {}
    puzzles.forEach(({score}) => {
      if (typeof(results[score]) === 'undefined') {results[score] = 0}
      results[score]++
    })
    const unsorted_array = []
    for (let i in results) {
      unsorted_array.push({reveals: Number(i), count: results[i]})
    }
    return unsorted_array
  }
</script>
<button on:click={()=>{current_page='guess'}}>Back</button>
<ul>
  <li>Your best puzzle was <em>{best_puzzle?.title.replaceAll('_',' ')}</em> which you got in {best_puzzle?.score} reveals!</li>
  <li>Your average score is {average_score} reveals.</li>
</ul>
<p>Distribution:</p>
  {#each distribution.sort((a,b) => a.reveals - b.reveals) as {reveals, count}}
    <div class='row'>
      <p>{reveals}</p>
      <p class='bar' style={`width: ${Math.floor((count/most_common_score)*100)}%`}>{count}</p>
    </div>
  {/each}
<style>
  .bar {
    color: rgba(0,0,0,0);
    text-align: right;
    padding-right: 1em;
  }
  .bar:hover {
    color: var(--text-color);
  }
  .row {
    display: grid;
    grid-template-columns: 2em auto;
    width: 80vw;
  }
  .row:nth-child(2n) > .bar {
    background-color: rgb(68, 102, 131);
  }
  .row:nth-child(2n+1) > .bar {
    background-color: rgb(69, 43, 82);
  }
</style>